import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HolidayquoteComponent } from './holidayquote.component';
import {MaterialuiModule} from '../../materialui/materialui.module';
import { HolidayquoteRoutingModule } from './holidayquote-routing.module';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { ThankYouComponentholiday } from './thank-you/thank-you.component';
// import { PaymentConfirmComponent } from './payment-confirm/payment-confirm.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [HolidayquoteComponent, 
    ThankYouComponentholiday, //PaymentConfirmComponent
],
  imports: [
    CommonModule,MaterialuiModule,HolidayquoteRoutingModule,NgxMatSelectSearchModule,
    MDBBootstrapModule.forRoot(), NgxMaskModule.forRoot(),
  ]
})
export class HolidayquoteModule { }
